"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.TitleWrapper = exports.ButtonsWrapper = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject, _templateObject2, _templateObject3;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var Wrapper = exports.Wrapper = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: var(--color-neutral-70);\n"])));
var TitleWrapper = exports.TitleWrapper = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin-bottom: var(--spacing-2);\n"])));
var ButtonsWrapper = exports.ButtonsWrapper = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-flow: row;\n  margin-top: var(--spacing-4);\n  align-items: center;\n  justify-content: flex-end;\n  flex-direction: column-reverse;\n  gap: var(--spacing-2);\n\n  @media (min-width: 840px) {\n    flex-direction: row;\n  }\n"])));